// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import TravelerBanner from '@homeaway/react-traveler-banner';
import withLingua from '../withLingua/withLingua';
import type {State as ReduxState} from '../../reducers/index';
import type {LinguaProps} from '../withLingua/withLingua';
import type {State as AbacusState} from '../../reducers/abacus';

type StateProps = {
    abacus: AbacusState
};
type OwnProps = StateProps & LinguaProps;

const Banner = ({messages, abacus}: OwnProps) => {
    const important = messages['traveler.msg.travelSafe'];
    const travelerMsg = messages['traveler.msg.covid.policy'];
    const learnMore = messages['traveler.msg.learn.more'];
    const url = messages['traveler.msg.covid.policy.url'];
    const labels = {
        important,
        travelerMsg,
        learnMore,
        url
    };
    return <TravelerBanner labels={labels} AbacusEvaluatedTests={abacus} />;
};

const mapStateToProps = ({abacus}: ReduxState): StateProps => {
    return {
        abacus
    };
};

const ConnectedTravelerBanner = compose(
    connect(mapStateToProps, null),
    withLingua({
        namespace: 'traveler/listing',
        category: 'messages'
    })
)(Banner);

export default ConnectedTravelerBanner;
